/* eslint-disable import/prefer-default-export */
import graphqlClient from '../graphql';
import {
  addExternalTransferPharmacyGql,
  deleteExternalTransferPharmacyGql,
  editExternalTransferPharmacyGql,
  getFulfillingPharmaciesGql,
  listFulfillingPharmaciesGql,
  listPharmaciesGql,
  transferOrderToFacilityGql,
  transferOrdersToExternalPharmacyGql,
  updateFulfillingPharmacyShippingDefaultGql,
} from './gql';

export const getFulfillingPharmaciesApi = ({ pharmacyId }) =>
  graphqlClient
    .request(getFulfillingPharmaciesGql, { pharmacyId })
    .then(({ getFulfillingPharmacies }) => getFulfillingPharmacies);

export const transferOrderToFacilityApi = ({
  orderIds,
  lineItemIds,
  fulfillingPharmacyId,
  toFacilityId,
}) =>
  graphqlClient
    .request(transferOrderToFacilityGql, {
      orderIds,
      lineItemIds,
      fulfillingPharmacyId: fulfillingPharmacyId || toFacilityId,
    })
    .then(({ transferOrderFulfillingPharmacy }) => transferOrderFulfillingPharmacy);

export const addExternalTransferPharmacyApi = (input) =>
  graphqlClient
    .request(addExternalTransferPharmacyGql, { input })
    .then(({ addExternalTransferPharmacy }) => addExternalTransferPharmacy);

export const listPharmaciesApi = ({ filter, sortBy } = {}) =>
  graphqlClient
    .request(listPharmaciesGql, { filter, sortBy })
    .then(({ listPharmacies }) => listPharmacies);

export const transferOrdersToExternalPharmacyApi = (input) =>
  graphqlClient
    .request(transferOrdersToExternalPharmacyGql, { input })
    .then(({ transferOrdersToExternalPharmacy }) => transferOrdersToExternalPharmacy);

export const listExternalPharmaciesApi = ({ sortBy } = {}) =>
  graphqlClient
    .request(listPharmaciesGql, {
      filter: { isExternal: true },
      sortBy,
    })
    .then(({ listPharmacies }) => listPharmacies);

export const editExternalTransferPharmacyApi = (input) =>
  graphqlClient
    .request(editExternalTransferPharmacyGql, { input })
    .then(({ editExternalTransferPharmacy }) => editExternalTransferPharmacy);

export const deleteExternalTransferPharmacyApi = (pharmacyId) =>
  graphqlClient
    .request(deleteExternalTransferPharmacyGql, { pharmacyId })
    .then(({ deleteExternalTransferPharmacy }) => deleteExternalTransferPharmacy);
export const listFulfillingPharmaciesApi = ({ filter } = {}) =>
  graphqlClient
    .request(listFulfillingPharmaciesGql, { filter })
    .then(({ listFulfillingPharmacies }) => listFulfillingPharmacies);

export const updateFulfillingPharmacyShippingDefaultApi = ({ fulfillingPharmacyId, routeTo }) =>
  graphqlClient
    .request(updateFulfillingPharmacyShippingDefaultGql, { fulfillingPharmacyId, routeTo })
    .then(({ updateFulfillingPharmacyShippingDefault }) => updateFulfillingPharmacyShippingDefault);
